import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5h3c2by94: FaireProductEntity = {
  token: "p_g5h3c2by94",
  type: "product",
  name: "Scent-Organix 4-Piece Travel Perfume Discovery Kit",
  brandToken: "b_72ivqmkinu",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/5ed9f30c39cbec52446e6cec63b60ef34b94ba898391d5bd83fd6bd86544ef96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd361ccacc5df37cd56a41d71e5b97b427a6cc5361ff618414f71ea066c6fded.jpeg",
  ],
  priceDollars: 2,
  description:
    "Let customers sample four nature-inspired fragrances with the Scent-Organix Discovery Kit. Each set includes four 2ml travel-size perfumes packaged in a gift-ready box. These scents are gentle, clean, and suitable for anyone.\n\nSet Includes:\n\n4 x 0.07 fl oz (2 ml) perfumes\n\nRise and Shine – Tangerine & Hibiscus\n\nI Am Bright – Pineapple & Salted Coconut\n\nI Am Radiant – Lily of the Valley & Jasmine\n\nSo Serene – Green Tea & Mandarin\n\nProduct Details:\n\nUnisex fragrances\n\nMade in France\n\nVegan, cruelty-free\n\nFree from parabens, sulfates, phthalates, and synthetic dyes\n\nWholesale Information:\n\nPrice on Faire is per 4-piece set\n\nPacked 12 sets per box",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:46.597Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
